/**
 * Settings —— 設定：字級 ＋ 語言（＋ 帳戶）
 * ⚠️ 字級只影響本機（localStorage ＋ `--font-scale`）。
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopBar from '../components/TopBar';
import { LocaleSwitcher } from '../components/LocaleSwitcher';
import { FONT_SCALE_OPTIONS, getFontScale, setFontScale } from '../lib/settings';

export default function Settings({ onLogout }: { onLogout: () => void }) {
  const { t } = useTranslation();
  const [scale, setScale] = useState(getFontScale());
  const pick = (s: number) => { setScale(s); setFontScale(s); };
  return (
    <main className="page">
      <TopBar title={t('settings.heading')} />

      <section className="card">
        <h2>{t('settings.font')}</h2>
        <div className="seg">
          {FONT_SCALE_OPTIONS.map((o) => (
            <button key={o.id} type="button" className={scale === o.scale ? 'on' : ''} onClick={() => pick(o.scale)}>
              {t(o.labelKey)}
            </button>
          ))}
        </div>
        <p className="note">{t('settings.font_note')}</p>
      </section>

      <section className="card">
        <h2>{t('settings.language')}</h2>
        <LocaleSwitcher />
      </section>

      <button type="button" className="cta secondary" onClick={onLogout}>{t('auth.sign_out')}</button>
    </main>
  );
}
